import { FormlyFieldConfig } from '@ngx-formly/core';
import { cloneDeep } from 'lodash';
import { ExpressionContainer } from '../../../../../backend-core-lib/cross-lib';
import { evaluateFormlyExpression } from './evaluate-formly-expression';

export function transformRawToFormly(
  fieldsRaw: FormlyFieldConfig[],
  forceDisable = false,
): FormlyFieldConfig[] {
  const newFieldsFormly: FormlyFieldConfig[] = cloneDeep(fieldsRaw);
  newFieldsFormly.forEach((newFieldFormly: FormlyFieldConfig) => {
    transformRawFieldConfigToFormly(newFieldFormly, forceDisable);
  });
  // this.fieldsFormly = newFieldsFormly;
  return newFieldsFormly;
}

function transformRawFieldConfigToFormly(
  field: FormlyFieldConfig,
  forceDisable = false,
): void {
  if (forceDisable) {
    if (field.props) {
      field.props.disabled = true;
    } else {
      field.props = {
        disabled: true,
      };
    }
  }
  if (field.expressions) {
    const fieldExpression = field.expressions;
    Object.keys(fieldExpression).forEach((keyExpression) => {
      if (keyExpression.indexOf('Raw') >= 0) {
        let currentKeyExpression = keyExpression.replace('Raw', '');
        let isPropsExpression = currentKeyExpression.indexOf('Prop') >= 0;
        currentKeyExpression = currentKeyExpression.replace('Prop', '');

        if (!forceDisable || currentKeyExpression !== 'disabled') {
          const expressionContainerDef: ExpressionContainer = fieldExpression[
            keyExpression
          ] as any as ExpressionContainer;

          if (expressionContainerDef.setting === 'NEVER') {
            return;
          }
          fieldExpression[
            isPropsExpression
              ? `props.${currentKeyExpression}`
              : currentKeyExpression
          ] = (field: FormlyFieldConfig) => {
            let root: any = field;
            // console.log(field);

            if (expressionContainerDef.modelType !== 'LOCAL') {
              while (root.parent) {
                root = root.parent;
                // console.log(JSON.parse(JSON.stringify(root?.model || {})));
              }
            }
            // console.log(JSON.parse(JSON.stringify(field?.model || {})));

            return evaluateFormlyExpression(root.model, expressionContainerDef);
            /* return (

            root.model[
              expressionContainerDef.expressionConditions[0].expressionCheck
                .operandLeftValue
            ] ===
            expressionContainerDef.expressionConditions[0].expressionCheck
              .operandRightValue
          );*/
          };
        }
      }
    });
  }
  if (field.fieldGroup) {
    (field.fieldGroup || []).forEach((field) => {
      transformRawFieldConfigToFormly(field, forceDisable);
    });
  }

  if (field?.fieldArray) {
    const fieldGroup = (field.fieldArray as FormlyFieldConfig)
      .fieldGroup as FormlyFieldConfig[];
    (fieldGroup || []).forEach((field) => {
      transformRawFieldConfigToFormly(field, forceDisable);
    });
  }
}
